import { ITabProps } from '@cian/ui-kit/prev';
import { RadioButtonGroup } from '@cian/ui-kit/radio';

import { ETab } from '../../types/tab';
import * as style from './Tabs.css';
import { TABS } from '../../constants/tabs';
import { Tab } from './Tab';

interface ITabsProps {
  activeTab: ETab;
  onChange(value: ETab): void;
  isMobile: boolean;
  reviewsCount: number;
  questionsCount: number;
}

export const Tabs = ({ activeTab, onChange, isMobile, reviewsCount, questionsCount }: ITabsProps) => {
  const getCount = (tab: ITabProps) => {
    return tab.value === ETab.Reviews ? reviewsCount : questionsCount;
  };

  return (
    <div className={style['tabs']}>
      {isMobile && (
        <RadioButtonGroup
          options={TABS.map(tab => ({ ...tab, label: tab.title }))}
          spliced={true}
          value={activeTab}
          onChange={e => onChange(e.target.value as ETab)}
        />
      )}
      {!isMobile &&
        TABS.map(tab => (
          <Tab
            key={tab.value}
            value={tab.value}
            title={tab.title}
            count={getCount(tab)}
            isActive={tab.value === activeTab}
            onClick={onChange}
          />
        ))}
    </div>
  );
};
